module.exports = __webpack_public_path__ + "img/oin-pay-bg.cc78ee1a.svg";